import { render, staticRenderFns } from "./ShoppingMall.vue?vue&type=template&id=b4ddcad0&scoped=true"
import script from "./ShoppingMall.vue?vue&type=script&lang=js"
export * from "./ShoppingMall.vue?vue&type=script&lang=js"
import style0 from "./ShoppingMall.vue?vue&type=style&index=0&id=b4ddcad0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ddcad0",
  null
  
)

export default component.exports